import { KeyofByValue } from '@synapex/tools/typescript';
import type { Invite, Permission } from './entity/selector';

export type {
  ActiveUser,
  AdvertiserAccount,
  Channel,
  Invite,
  NormalSubscription,
  OrdData,
  Owner,
  OwnerSettings,
  Permission,
  Site,
  Subscription,
  User,
  Workspace,
  ExistentAccountChannelRequest,
  NewAccountChannelRequest,
} from './entity/selector';
export * as Selector from './entity/selector';

export const coerceToInvite = <Fallback>(
  maybeInvite: unknown,
  fallback: Fallback,
): Invite | Fallback => {
  if (!(typeof maybeInvite === 'object' && maybeInvite)) {
    return fallback;
  }

  if (
    !(
      'token' in maybeInvite &&
      typeof maybeInvite.token === 'string' &&
      maybeInvite.token
    )
  ) {
    return fallback;
  }

  return {
    token: maybeInvite.token,
    admin: true,
    audience: true,
    invite_link: true,
    send_pulse: true,
    one_time: false,
  };
};

export type PermissionKey = KeyofByValue<Permission, boolean>;
